import { orderApi } from '@/api';
import QueryParameterBuilder from '@/lib/query-parameter/QueryParameterBuilder';
import * as filterOption from '@/lib/query-parameter/filter';
import { embed, embedField, field, } from '@/lib/query-parameter/resource';
import { desc, injectSortParamHelper, } from '@/lib/query-parameter/sortby';
import { orderEvent, orderStatus, } from '@/constants';
import Order from '@/entity/Order';
import PaginationOutput from '@/helpers/PaginationOutput';
const { between, include, injectFilterParamHelper } = filterOption;
export default {
    /**
     * 안쓰임
     * 백엔드에서도 제거 예정
     * https://barogo.slack.com/archives/C04UP4VFCKA/p1734651951099709
     */
    async getOrderList({ 
    // 필수
    betweenData, 
    // 필수
    statusCode, pageNumber, pageSize, hubIds, filters = [], sortOption = [], }) {
        const params = new QueryParameterBuilder()
            .addHubIds(hubIds)
            .addFilters(between(betweenData))
            .addFilters(include('statusCode', ...statusCode))
            .addFields(field('todayNumber', 'distributorId', 'distanceKilometer', 'orderId', 'statusCode', 'typeCode', 'payTypeCode', 'goodsPayType', 'deliveryPayType', 'payCashAmount', 'payCardAmount', 'prePayAmount', 'orderAmount', 'cardName', 'cardApproveNumber', 'purchaseDeliveryCharge', 'deliveryAmount', 'memo', 'promotionSupportAmount', 
        // 허브
        'hubId', 'hubName', 
        // 픽업지 주소
        'pickupLongitude', 'pickupLatitude', 'pickupAddressSiDo', 'pickupAddressSiGunGu', 'pickupAddressDong', 'pickupAddressLi', 'pickupAddressJibun', 'pickupAddressRoad', 'pickupAddressBuildingNumber', 'pickupAddressBuildingName', 'pickupAddressDetail', 'pickupAddressMemo', 
        // 도착지 주소
        'dropLongitude', 'dropLatitude', 'dropAddressDetail', 'dropAddressDong', 'dropAddressLi', 'dropAddressJibun', 'dropAddressRoad', 'dropAddressBuildingNumber', 'dropAddressBuildingName', 
        // 고객
        'receiverPhone', 'customerSafePhone', 
        // 시간
        'orderedAt', 'pickupExpectedAt', 'allocatedAt', 'pickedUpAt', 'finishedAt', 'canceledAt', 'updatedAt', 
        // 수행 워커
        'allocatedDistributorId', 'allocatedHubId', 'allocatedWorkerCode', 'allocatedWorkerName', 'allocatedWorkerPhone', 
        // 수행 허브
        'allocatedHubName', 
        // 상점
        'storeId', 'storeName', 'storePhone', 'allocatedCancelPenaltyAmount', 'allocatedCancelPenaltyCount'))
            // .addFields(
            //   embedField('store', 'addressMemo', 'name', 'addressDong', 'addressJibun',
            //     'addressRoad', 'addressBuildingNumber', 'addressBuildingName'),
            // )
            // .addEmbeds(embed('store'))
            .addPageNumber(pageNumber)
            .addPageSize(pageSize);
        injectFilterParamHelper(params, filters);
        injectSortParamHelper(params, sortOption);
        const response = await orderApi.getOrderList(params.build());
        return PaginationOutput.adaptorFactory(response);
    },
    async getOrder({ orderId }) {
        const params = new QueryParameterBuilder()
            .addFields(field('statusCode', 'orderedAt', 'allocatedAt', 'pickedUpAt', 'finishedAt', 'canceledAt', 'cancelTypeCode', 'pickupExpectedAt', 'todayNumber', 'orderId', 'customerNumber', 'customerPhone', 'customerPhone2', 'customerName', 'distributorId', 'hubId', 'hubName', 'storeId', 'storeName', 'allocatedWorkerCode', 'allocatedWorkerName', 'allocatedDistributorId', 'allocatedDistributorName', 'allocatedHubId', 'allocatedHubName', 'memo', 'pdaMemo', 'pickupAddressSiDo', 'pickupAddressSiGunGu', 'pickupAddressDong', 'pickupAddressLi', 'pickupAddressJibun', 'pickupAddressRoad', 'pickupAddressBuildingNumber', 'pickupAddressBuildingName', 'pickupAddressDetail', 'pickupLongitude', 'pickupLatitude', 'dropAddressSiDo', 'dropAddressSiGunGu', 'dropAddressDong', 'dropAddressLi', 'dropAddressJibun', 'dropAddressRoad', 'dropAddressBuildingNumber', 'dropAddressBuildingName', 'dropAddressDetail', 'dropLongitude', 'dropLatitude', 'orderAmount', 'deliveryAmount', 'deliveryPayType', 'prePayAmount', 'payCashAmount', 'payCardAmount', 'goodsNames', 'allocatedWorkerPhone', 'storePhone', 'cardApproveNumber', 'prepareTimeMinute', 'payTypeCode', 'goodsPayType', 'allocatedWorkerHubNumber', 'pickupAddressMemo', 'cardName', 'distanceKilometer', 'customerSafePhone', 'receiverPhone', 'purchaseDeliveryCharge', 'workerSupportAmount', 'deliveryAddYn', 'configSurcharge', 'irregularSurcharge', 'areaSurcharge', 'goodsPriceSurcharge', 'typeCode', 'promotionSupportAmount', 'allocatedCancelPenaltyAmount', 'allocatedCancelPenaltyCount', 'orderAgencyId', 'orderAgencyOptions'))
            .addFields(embedField('worker', 'phone'))
            .addEmbeds(embed('worker'))
            .addEmbeds(embed('hubConfiguration'))
            .build();
        const response = await orderApi.getOrder(orderId, params);
        return response.data;
    },
    // 배차 요청
    async workerRequest(serviceData) {
        serviceData.setOrderEvent(orderEvent.WORKER_REQUEST);
        const res = await orderApi.postOrderEvent(serviceData.orderId, serviceData.createReqBody());
        const { data: { data, }, } = res;
        return {
            event: orderEvent.WORKER_REQUEST,
            order: data,
        };
    },
    /**
     * 즉시 배차
     */
    async allocate(serviceData) {
        serviceData.setOrderEvent(orderEvent.ALLOCATE);
        const res = await orderApi.postOrderEvent(serviceData.orderId, serviceData.createReqBody());
        const { data: { data, }, } = res;
        return {
            event: orderEvent.ALLOCATE,
            order: data,
        };
    },
    /**
     * 재배차
     */
    async reallocate(serviceData) {
        serviceData.setOrderEvent(orderEvent.REALLOCATE);
        const res = await orderApi.postOrderEvent(serviceData.orderId, serviceData.createReqBody());
        const { data: { data, }, } = res;
        return {
            event: orderEvent.REALLOCATE,
            order: data,
        };
    },
    /**
     * 배차 취소
     * @returns
     */
    async allocateCancel(serviceData) {
        serviceData.setOrderEvent(orderEvent.ALLOCATE_CANCEL);
        const { data: { data } } = await orderApi.postOrderEvent(serviceData.orderId, serviceData.createReqBody());
        return {
            event: orderEvent.ALLOCATE_CANCEL,
            order: data,
        };
    },
    /**
     * 주문 취소 (배달 취소)
     * @returns
     */
    async cancel(serviceData) {
        serviceData.setOrderEvent(orderEvent.CANCEL);
        const { data: { data } } = await orderApi.postOrderEvent(serviceData.orderId, serviceData.createReqBody());
        return {
            event: orderEvent.CANCEL,
            order: data,
        };
    },
    async getGoods({ orderId }) {
        const params = new QueryParameterBuilder()
            .addFields(field('goodsNumber', 'sellPrice', 'count', 'name', 'goodsGroup'))
            .build();
        const response = await orderApi.getGoods(orderId, params);
        return response.data;
    },
    async getPayments({ orderId }) {
        const response = await orderApi.getPayments(orderId);
        return response.data;
    },
    async adjustPayment({ orderId, payCashAmount, payCardAmount, prePayAmount, isUntact, goodsSummary = '', orderGoods = [], }) {
        const data = {
            payCashAmount,
            payCardAmount,
            prePayAmount,
            isUntact,
            goodsSummary,
            orderGoods,
        };
        const response = await orderApi.putPaymentsInfo(orderId, data);
        return response.data;
    },
    async changePickupWishAt({ orderId, pickupWishAt }) {
        const data = {
            pickupWishAt,
        };
        const response = await orderApi.putPickupWishAt(orderId, data);
        return response.data;
    },
    async changePickupDelayWishAt({ orderId, pickupDelayWishAt }) {
        const data = {
            pickupDelayWishAt,
        };
        const response = await orderApi.postPickupDelayWishAt(orderId, data);
        return response.data;
    },
    async adjustDeliveryAmount({ orderId, deliveryAmount }) {
        const data = {
            deliveryAmount,
        };
        const response = await orderApi.putAdjustDeliveryAmount(orderId, data);
        return response.data;
    },
    async changeDropInfo({ orderId, ...data }) {
        const response = await orderApi.putDropInfo(orderId, data);
        return response.data;
    },
    async getOrderHistory({ orderId }) {
        const params = new QueryParameterBuilder()
            .addEmbeds(embed('user', 'worker'))
            .addSortBy(desc('createdAt'))
            .build();
        const response = await orderApi.getOrderHistory(orderId, params);
        return response.data;
    },
    async addWorkerSupportAmount({ orderId, workerSupportAmount }) {
        const data = {
            workerSupportAmount,
        };
        const response = await orderApi.putWorkerSupportAmount(orderId, data);
        return response.data;
    },
    async requestBaromoneyRemittance({ memo, orderId, receiverAccountType, remittanceBaromoney, }) {
        const data = {
            memo,
            receiverAccountType,
            remittanceBaromoney,
        };
        const response = await orderApi.postBaromoneyRemittance(orderId, data);
        return response.data;
    },
    /**
     * 배달내역
     */
    async getDeliveryHistory(payload) {
        const { hubIds, pageNumber, pageSize, sortOption, } = payload;
        const params = new QueryParameterBuilder()
            .addHubIds(hubIds)
            .addPageNumber(pageNumber)
            .addPageSize(pageSize);
        injectSortParamHelper(params, sortOption);
        const urlSearchParams = params.build();
        [
            'statusCodes',
            'fromOrderedAt',
            'toOrderedAt',
            'orderOwnerType',
            'searchPayType',
            'searchType',
            'searchText',
        ].forEach((key) => {
            const value = Array.isArray(payload[key])
                ? payload[key].join(',')
                : payload[key];
            if (!value
                || value === 'ALL') {
                return;
            }
            urlSearchParams.append(key, payload[key]);
        });
        const response = await orderApi.getOrderListByDone(urlSearchParams);
        return PaginationOutput.adaptorFactory(response);
    },
    /**
     * 지도관제 주문리스트
     */
    async getMapControlOrderList(payload) {
        const { pageNumber, pageSize, hubIds, } = payload;
        const statusCodes = [
            orderStatus.ACCEPTED.code,
            orderStatus.WORKER_REQUESTED.code,
            orderStatus.ALLOCATED.code,
            orderStatus.PICKUP_ARRIVED.code,
            orderStatus.PICKUP_FINISHED.code,
        ];
        const params = new QueryParameterBuilder()
            .addHubIds(hubIds)
            .addPageNumber(pageNumber)
            .addPageSize(pageSize);
        const urlSearchParams = params.build();
        urlSearchParams.append('statusCodes', statusCodes.join(','));
        const response = await orderApi.getOrderListByProcess(urlSearchParams);
        return PaginationOutput.adaptorFactory(response);
    },
    /**
     * 목록관제 주문리스트
     */
    async getListControlOrderList(payload) {
        const { pageNumber, pageSize, hubIds, } = payload;
        const statusCodes = [
            orderStatus.ACCEPTED.code,
            orderStatus.WORKER_REQUESTED.code,
            orderStatus.ALLOCATED.code,
            orderStatus.PICKUP_ARRIVED.code,
            orderStatus.PICKUP_FINISHED.code,
            orderStatus.SELF_DELIVERY.code,
            orderStatus.DROP_FINISHED.code,
            orderStatus.CANCELED.code,
        ];
        const params = new QueryParameterBuilder()
            .addHubIds(hubIds)
            .addPageNumber(pageNumber)
            .addPageSize(pageSize);
        const urlSearchParams = params.build();
        urlSearchParams.append('statusCodes', statusCodes.join(','));
        const response = await orderApi.getOrderListByProcess(urlSearchParams);
        return PaginationOutput.adaptorFactory(response);
    },
    /**
     * 라이더 수행상황 조회
     */
    async getOrderByWorkerCode({ workerCode }) {
        const { data } = await orderApi.getOrderByWorkerCode({
            workerCode,
        });
        return data.data.map((item) => new Order(item));
    },
};
